import React, { useState } from "react";
import { TextField, Button, Typography, Box, InputAdornment, Grid, Paper, IconButton, FormControl, Alert, Dialog, DialogTitle, DialogContent, DialogActions, Divider } from "@mui/material";
import { useForm } from "react-hook-form";
import { IconCheck, IconCloudLockOpen, IconEye, IconEyeOff, IconX } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import loginIllustration from ".././graphic.svg";
import axios from "axios";
import { BeatLoader } from "react-spinners";
import PageContainer from "../Pages/Pagecontainer";
// import Logo from '.././Images/logo1.png'
import Logo from '.././Images/logo-dark.png'

const UserPasswordChange = () => {
      const { register: registerpassword, handleSubmit: handlepassword, watch, trigger: triggerpassword, formState: { errors: passworderror } } = useForm();
      const [showPassword, setShowPassword] = useState(false);
      const [showConfirmPassword, setShowConfirmPassword] = useState(false);
        const [open, setopen] = useState(false)
        const [loading, setloading] = useState(false)
        const navigate = useNavigate()
        const urlParams = new URLSearchParams(window.location.search);
        const userid = urlParams.get('userId');
      const onPasswordSubmit = async (data) => {
        setloading(true)
        try {
          console.log(data);
    
          let req = {
            password: data.password,
            password2: data.confirmPassword
          };
          let config = axios.defaults.headers.common = { 'Authorization': `` }
          const response = await axios.patch(`apiV1/change-passwordv2/${userid}/`, req, config);
          if (response.status == 200) {
            // setshowpasswordChange(true)
            setopen(true)
            setloading(false)
          }
          console.log(response);
        } catch (error) {
          console.error('Error generating test:', error.response ? error.response.data : error.message);
          setloading(false)
    
        }
    
      };
  return (
    <>
<PageContainer title="SmartInvestorDeck | ForgotPassword">
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        height="100vh"
        sx={{
          backgroundImage: `url(${loginIllustration})`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '45%'
        }}
      >
        <Paper
          elevation={3}
          sx={{
            borderRadius: 3,
            overflow: 'hidden',
            maxWidth: 400,
            width: '100%',
            padding: 4,
            background: 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(10px)'
          }}
        >
          <Box>
          <Box sx={{ textAlign: "center", mb: 2 }}>
          <img src={Logo} alt="logo" style={{ width: "250px" }} />
          </Box>
            <Typography variant="h5" fontWeight="bold" textAlign="center" gutterBottom>
              Reset Your Password
            </Typography>
            <Typography variant="body2" textAlign="center" sx={{ mb: 2 }}>
              Enter your new password below and confirm it to reset your account password.
            </Typography>
            <form
              onSubmit={handlepassword(onPasswordSubmit)}
              autoComplete="off"
              autoCorrect="off"
              spellCheck="false"
            >
              <input type="text" style={{ display: 'none' }} />
              <input type="password" style={{ display: 'none' }} />

              <FormControl variant="standard" fullWidth>
                <Typography variant="body2" gutterBottom>Password</Typography>
                <TextField
                  fullWidth
                  id="new-password"
                  type={showPassword ? 'text' : 'password'}
                  inputProps={{
                    autoComplete: 'new-password',
                    autoCorrect: 'off',
                    spellCheck: 'false',
                    autoCapitalize: 'none'
                  }}
                  {...registerpassword('password', {
                    required: 'Password is required',
                    pattern: {
                      value: /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,16}$/,
                      message:
                        'Password must be 8-16 characters, with at least one digit, one lowercase, and one uppercase letter.'
                    }
                  })}
                  onKeyUp={() => triggerpassword('password')}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                          {showPassword ? <IconEye /> : <IconEyeOff />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  error={!!passworderror.password}
                  helperText={passworderror.password?.message}
                />
              </FormControl>

              <FormControl variant="standard" fullWidth margin="dense">
                <Typography variant="body2" gutterBottom>Confirm Password</Typography>
                <TextField
                  fullWidth
                  id="confirm-password-input"
                  type={showConfirmPassword ? 'text' : 'password'}
                  inputProps={{
                    autoComplete: 'new-password',
                    autoCorrect: 'off',
                    spellCheck: 'false',
                    autoCapitalize: 'none'
                  }}
                  {...registerpassword('confirmPassword', {
                    required: 'Confirm Password is required',
                    validate: (value) => value === watch('password') || 'Passwords do not match'
                  })}
                  onKeyUp={() => triggerpassword('confirmPassword')}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end">
                          {showConfirmPassword ? <IconEye /> :  <IconEyeOff />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  error={!!passworderror.confirmPassword}
                  helperText={passworderror.confirmPassword?.message}
                />
              </FormControl>

              <Button
                type="submit"
                variant="contained"
                fullWidth
                sx={{ mt: 2, bgcolor: '#07659c' }}
              >
                {loading ? <BeatLoader size={20} color="#77b0d1" /> : 'Update Password'}
              </Button>
            </form>
          </Box>
        </Paper>
      </Grid>
    </PageContainer>
    <Dialog open={open} onClose={(event, reason) => {
            if (reason !== "backdropClick") {
              setopen(false);
            }
          }} fullWidth>
            <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              Success
            </DialogTitle>
            <Divider />
    
            <DialogContent sx={{ textAlign: "center" }}>
              <Box sx={{ textAlign: "center", mb: 2 }}>
                <IconButton sx={{ backgroundColor: "#c6f1d1", color: "white", padding: 3, "&:hover": { backgroundColor: "#4b75fd" } }}>
                  <IconCheck color="#198b08" size={50} />
                </IconButton>
              </Box>
              Your password has been updated successfully!
            </DialogContent>
            <Divider />
            <DialogActions sx={{ justifyContent: "flex-end" }}>
              <Button onClick={() => navigate('/')} color="success" variant="contained">
                Okay
              </Button>
            </DialogActions>
          </Dialog>
          </>
      
  )
}

export default UserPasswordChange
